import { Typography as OriginTypography } from './Typography';
import { TypographyText, ITypographyTextProps } from './TypographyText';
import { TypographyLink, ITypographyLinkProps } from './TypographyLink';
import { TypographyTitle, ITypographyTitleProps } from './TypographyTitle';
import {
  TypographyParagraph,
  ITypographyParagraphProps,
} from './TypographyParagraph';

export type TypographyProps = typeof OriginTypography & {
  Text: typeof TypographyText;
  Link: typeof TypographyLink;
  Title: typeof TypographyTitle;
  Paragraph: typeof TypographyParagraph;
};

const Typography = OriginTypography as TypographyProps;

Typography.Text = TypographyText;
Typography.Link = TypographyLink;
Typography.Title = TypographyTitle;
Typography.Paragraph = TypographyParagraph;

export { Typography };
export type {
  ITypographyLinkProps,
  ITypographyParagraphProps,
  ITypographyTextProps,
  ITypographyTitleProps,
};
